import script from "./AboutMsg.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutMsg.vue?vue&type=script&setup=true&lang=js"

import "./AboutMsg.vue?vue&type=style&index=0&id=5cc3c34c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cc3c34c"]])

export default __exports__